import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/kadis/question-bank'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(questionBank) {
    return http.post(`${resource}`, questionBank)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(questionBank, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, questionBank, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
